import React from "react"
import { Region } from "lib"

export const DefaultLayout = ({ entity }) => <Region entity={entity} dynamic />
export const nodeLayout = (node, location) => DefaultLayout
